function equalHeight() {
    $.fn.extend({
        equalHeights: function () {
            var top = 0;
            var row = [];
            var classname = ("equalHeights" + Math.random()).replace(".", "");
            $(this)
                .each(function () {
                    var thistop = $(this).offset().top;
                    if (thistop > top) {
                        $("." + classname).removeClass(classname);
                        top = thistop;
                    }
                    $(this).addClass(classname);
                    $(this).height("auto");
                    var h = Math.max.apply(
                        null,
                        $("." + classname)
                        .map(function () {
                            return $(this).outerHeight();
                        })
                        .get()
                    );
                    $("." + classname).outerHeight(h);
                })
                .removeClass(classname);
        }
    });
    $(".product-card__content .product-top__content").equalHeights();
    $(".product-card__content .product-bottom__content").equalHeights();
}

$(document).ready(function () { 
	equalHeight();
  
    // hide all contents accept from the first div
    $('.tabContent div:not(:first)').toggle();
    $('.tab li').click(function () {        
        var corresponding = $(this).data("id");

        // hide all content divs
        $('.tabContent div').hide();

        // show content of corresponding tab
        $('div.' + corresponding).toggle();

        // remove active class from currently not active tabs
        $('.tab li').removeClass('active');

        // add active class to clicked tab
        $(this).addClass('active');
    }); 
});

$(window).resize(function () { 
    equalHeight(); 
});
$(window).on("load", function () { 
    equalHeight(); 
});
